import Http from '../../../http';
import {
  FETCH_QUICK_BOOKS_SETTINGS,
  STORE_QUICK_BOOKS_ACCOUNT_MAP,
  DISCONNECT_QUICK_BOOKS_ACCOUNT,
} from './constants';

export const fetchQuickBooksSettingsAction = settings => ({
  type: FETCH_QUICK_BOOKS_SETTINGS,
  payload: settings,
});

const storeQuickBooksAccountMapAction = map => ({
  type: STORE_QUICK_BOOKS_ACCOUNT_MAP,
  payload: map,
});

const disconnectQuickBooksAccountAction = () => ({
  type: DISCONNECT_QUICK_BOOKS_ACCOUNT,
});

export const fetchQuickBooksSettings = (type, id, callback) => dispatch =>
  Http.get(`/accounting/${type}/${id}/get-quick-books-settings`)
  .then((result) => {
    const { isConnected, map, settings } = result;
    dispatch(storeQuickBooksAccountMapAction(map));
    dispatch(fetchQuickBooksSettingsAction({
      isConnected,
      ...settings,
    }));
    if (typeof callback === 'function') {
      callback(result);
    }
  });

export const storeQuickBooksAccountMap = (id, accountMap) => dispatch => (
  Http.put(`/accounting/shop/${id}/quick-books/store-bank-deposit-accounts-map`, accountMap)
  .then(map => dispatch(storeQuickBooksAccountMapAction(map)))
);

export const disconnectFromQuickBooks = id => dispatch => (
  Http.get(`/accounting/shop/${id}/quick-books/disconnect`)
  .then(({ status }) => {
    if (status) {
      dispatch(disconnectQuickBooksAccountAction());
    }
  })
);
